import { Profile } from 'model/modules/profile/profile';
import mapProfileFromApi from 'rtkQuery/sharespro/mapper/modules/profile/mapProfileFromApi';
import sharesproApi from 'rtkQuery/sharespro/sharesproApiService';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';
import mapPaginationListFromApi from 'rtkQuery/sharespro/mapper/shared/mapPaginationListFromApi';
import mapOnlineDocumentFromApi from 'rtkQuery/sharespro/mapper/modules/onlineDocument/mapOnlineDocumentFromApi';
import { OtpId } from 'model/modules/otp/types';

export const profileApi = sharesproApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchProfile: builder.query<Profile, void>({
      query: () => ({
        url: '/v3/profile/get',
        method: 'GET',
        sendToken: true,
      }),
      transformResponse(
        baseQueryReturnValue: SharesproApiResponse<ApiProfileResponseData>
      ) {
        return mapProfileFromApi(baseQueryReturnValue);
      },
    }),
    fetchOnlineDocuments: builder.query<
      PaginationList<OnlineDocument>,
      ApiPaginationQueryParams
    >({
      query: (params) => ({
        url: '/v3/client/online-document/list',
        method: 'GET',
        sendToken: true,
        params,
      }),
      transformResponse(baseQueryReturnValue: SharesproApiResponse<any>) {
        return mapPaginationListFromApi(
          baseQueryReturnValue.data,
          mapOnlineDocumentFromApi
        );
      },
    }),
    updateProfile: builder.mutation<Profile, ApiUpdateProfileRequestData>({
      query: (data) => ({
        url: '/v4/client/profile/update',
        method: 'PATCH',
        sendToken: true,
        body: data,
      }),
      transformResponse(
        baseQueryReturnValue: SharesproApiResponse<ApiProfileResponseData>
      ) {
        return mapProfileFromApi(baseQueryReturnValue);
      },
      async onQueryStarted(data, { dispatch, queryFulfilled }) {
      const resp = await queryFulfilled;
        dispatch(
          profileApi.util.updateQueryData(
            'fetchProfile',
            undefined,
            (draft) => {
              return { ...resp.data };
            }
          )
        );
      },
    }),
    updateAgreements: builder.mutation<void, ApiUpdateAgreementsRequest>({
      query: (data) => ({
        url: '/v3/client/profile/agreements',
        method: 'PATCH',
        sendToken: true,
        body: data,
      }),
    }),
    requestDocumentSign: builder.mutation<OtpId, ID>({
      query: (id) => ({
        url: '/v3/client/online-document/sign',
        method: 'POST',
        sendToken: true,
        params: { id },
      }),
      transformResponse(
        baseQueryReturnValue: SharesproApiResponse<ApiRequestOtpResponse>
      ) {
        return baseQueryReturnValue.data.otp_id;
      },
    }),
    checkSignDocument: builder.mutation<OnlineDocument, ApiSignDocumentRequest>(
      {
        query: (data) => ({
          url: '/v3/client/online-document/sign-check',
          method: 'POST',
          sendToken: true,
          params: { id: data.otpId },
          body: { code: data.code },
        }),
        transformResponse(baseQueryReturnValue: ApiOnlineDocumentResponse) {
          return mapOnlineDocumentFromApi(baseQueryReturnValue);
        },
      }
    ),
    disconnectTelegram: builder.mutation<boolean, void>({
      query: (data) => ({
        url: '/v3/client/telegram/settings/disconnect',
        method: 'POST',
        sendToken: true,
      }),
      transformResponse(baseQueryReturnValue: boolean) {
        return baseQueryReturnValue;
      },
    }),
  }),
});

export const {
  useFetchProfileQuery,
  useFetchOnlineDocumentsQuery,
  useUpdateProfileMutation,
  useUpdateAgreementsMutation,
  useLazyFetchProfileQuery,
  useRequestDocumentSignMutation,
  useCheckSignDocumentMutation,
  useDisconnectTelegramMutation,

} = profileApi;
